import './apps/portal/src/polyfills.ts';
import 'zone.js/testing';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
